module.exports = __webpack_public_path__ + "static/media/action-three-rings.da7a5f5b.svg";